<div class="loading" *ngIf="loading">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</div>

<div class="header">
	<div
		class="session-tag zk-mr-1"
		*ngIf="appointment.sessionModel === 'reception_session'"
	>
		{{ 'SESSION.SIDEBAR.SESSION_MODEL_RECEPTION' | translate }}
	</div>
	<div
		class="session-tag zk-mr-1"
		*ngIf="appointment.sessionModel === 'coordinated_care'"
	>
		{{ 'SESSION.SIDEBAR.SESSION_MODEL_COORDINATED_CARE' | translate }}
	</div>
	<div
		class="session-tag zk-mr-1"
		*ngIf="appointment.sessionModel === 'screening_coordinated_care'"
	>
		{{ 'SESSION.SIDEBAR.SESSION_MODEL_SCREENING' | translate }}
	</div>

	<div class="session-tag" *ngIf="numberOfSessions">
		{{ numberOfSessions }}{{ 'SESSION.SIDEBAR.SESSION' | translate }}
	</div>

	<span
		class="freud-icon freud-icon-md freud-icon-messages"
		[pTooltip]="'SESSION.SIDEBAR.CHAT' | translate"
		tooltipPosition="left"
		(click)="emDisplayStateChange.emit('chat')"
	></span>

	<span
		class="freud-icon freud-icon-md freud-icon-window-minimize"
		[pTooltip]="'SESSION.SIDEBAR.MINIMIZE' | translate"
		tooltipPosition="left"
		(click)="emDisplayStateChange.emit('switch')"
	></span>
</div>

<div class="animationLimitWrapper">
	<vc-userinfo
		(close)="toggleUserForm()"
		*ngIf="!showForm"
		[@slideDownAnimation]
		[contactData]="sessionContact"
	></vc-userinfo>

	<vc-userform
		(cancel)="toggleUserForm()"
		(dataUpdate)="updateClientData($event)"
		*ngIf="showForm"
		[@slideDownAnimation]
		[contactData]="sessionContact"
		[loading]="savingData"
	></vc-userform>
</div>

<div class="cgi-severity zk-flex zk-mb-4">
	<cgi-severity
		class="cgi-severity"
		*ngIf="cgiBaselineAnswer"
		[severity]="cgiBaselineAnswer.selectedOption"
		[type]="cgiBaselineAnswer.type"
		mode="vc"
	>
	</cgi-severity>
</div>

<tabs-row
	[selectedTabIndex]="activeTabIndex"
	[tabList]="tabs"
	(changeTab)="changeTab($event)"
></tabs-row>

<div class="body">
	<!-- Evolução -->
	<div class="zk-relative" *ngIf="currentTab === 'service_evolution'">
		<div
			*ngIf="
				!unifiedPromptuaryService.isPromptuaryCreated &&
				unifiedPromptuaryService.isLoading
			"
			class="zk-flex zk-h-20 zk-w-full zk-items-center zk-justify-center"
		>
			<freud-loader></freud-loader>
		</div>
		<autosave-textarea
			*ngIf="
				unifiedPromptuaryService.isPromptuaryCreated &&
				!unifiedPromptuaryService.isLoading
			"
			[ngClass]="{ active: currentTab === 'service_evolution' }"
			[maxLength]="3000"
			[appointment]="appointment"
			placeholder="{{ 'TEXTAREA.PROMPTUARY.PLACEHOLDER' | translate }}"
			property="serviceEvolution"
			service="autoSaveField"
			title="{{ 'TEXTAREA.PROMPTUARY.TITLE' | translate }}"
			(valueChanged)="onServiceEvolutionChange($event)"
			helperTooltip="{{ 'TEXTAREA.PROMPTUARY.TOOLTIP' | translate }}"
		></autosave-textarea>
		<div
			*ngIf="
				!unifiedPromptuaryService.isLoading &&
				!unifiedPromptuaryService.isPromptuaryCreated
			"
		>
			Não foi possivel carregar a evolução do atendimento.
		</div>
	</div>
	<!-- Histórico de registros -->
	<vc-history
		[contactId]="appointment.contact.id"
		*ngIf="currentTab === 'historic'"
		(redirectToDocumentaryRegister)="changeTab(0)"
	></vc-history>
	<!-- Registro documental -->
	<div *ngIf="currentTab === 'documentary_record'">
		<autosave-textarea
			[ngClass]="{ active: currentTab === 'documentary_record' }"
			[maxLength]="3000"
			[appointment]="appointment"
			placeholder="{{ 'TEXTAREA.DOCUMENTARY_RECORD.PLACEHOLDER' | translate }}"
			property="session-note"
			(valueChanged)="onDocumentaryRegisterChange($event)"
			[forceValue]="tempCopiedPrivateNote"
			service="saveDocumentaryRecord"
			title="{{ 'TEXTAREA.DOCUMENTARY_RECORD.TITLE' | translate }}"
			helperTooltip="{{ 'TEXTAREA.DOCUMENTARY_RECORD.TOOLTIP' | translate }}"
		></autosave-textarea>
	</div>
</div>
<!-- Flags -->
<div class="footer">
	<div
		*ngIf="currentTab === 'documentary_record' && serviceEvolution.length > 0"
		class="zk-flex zk-justify-between zk-items-center zk-gap-3 zk-mt-2"
	>
		<div class="zk-flex zk-gap-2">
			<span class="freud-icon freud-icon-bolt freud-icon-md"></span>
			<span>{{
				isDocumentaryRecordCopied || serviceEvolution === documentaryRecordValue
					? ('SESSION.SIDEBAR.DOCUMENTARY_RECORD_COPIED' | translate)
					: ('SESSION.SIDEBAR.DOCUMENTARY_RECORD_COPY' | translate)
			}}</span>
		</div>
		<freud-button
			color="secondary"
			(click)="copyToDocumentaryRecord()"
			[disabled]="
				isDocumentaryRecordCopied || serviceEvolution === documentaryRecordValue
			"
		>
			{{
				(!isDocumentaryRecordCopied
					? 'SESSION.SIDEBAR.COPY'
					: 'SESSION.SIDEBAR.COPIED'
				) | translate
			}}
		</freud-button>
	</div>
	<vc-schedule-alert [appointment]="appointment"></vc-schedule-alert>
</div>
<freud-confirm-dialog></freud-confirm-dialog>
